"use strict";
export var DynamicConfigs = /* @__PURE__ */ ((DynamicConfigs2) => {
  DynamicConfigs2["Swap"] = "swap_config";
  DynamicConfigs2["NetworkRequests"] = "network_requests";
  DynamicConfigs2["Chains"] = "chains";
  DynamicConfigs2["HomeScreenExploreTokens"] = "home_screen_explore_tokens";
  DynamicConfigs2["ForceUpgrade"] = "force_upgrade";
  DynamicConfigs2["OnDeviceRecovery"] = "on_device_recovery";
  DynamicConfigs2["UwuLink"] = "uwulink_config";
  DynamicConfigs2["GasStrategies"] = "gas_strategy";
  DynamicConfigs2["DatadogSessionSampleRate"] = "datadog_session_sample_rate";
  DynamicConfigs2["DatadogIgnoredErrors"] = "datadog_ignored_errors";
  DynamicConfigs2["EmbeddedWallet"] = "embedded_wallet";
  DynamicConfigs2["AstroChain"] = "astro_chain";
  DynamicConfigs2["BlockedNftCollections"] = "blocked_nft_collections";
  DynamicConfigs2["ExternallyConnectableExtension"] = "externally_connectable_extension";
  DynamicConfigs2["LPConfig"] = "lp_config";
  return DynamicConfigs2;
})(DynamicConfigs || {});
export var SwapConfigKey = /* @__PURE__ */ ((SwapConfigKey2) => {
  SwapConfigKey2["AverageL1BlockTimeMs"] = "averageL1BlockTimeMs";
  SwapConfigKey2["AverageL2BlockTimeMs"] = "averageL2BlockTimeMs";
  SwapConfigKey2["TradingApiSwapRequestMs"] = "tradingApiSwapRequestMs";
  SwapConfigKey2["MonadTestnetPollingIntervalMs"] = "monadTestnetPollingIntervalMs";
  SwapConfigKey2["MinAutoSlippageToleranceL2"] = "minAutoSlippageToleranceL2";
  SwapConfigKey2["EthSwapMinGasAmount"] = "ethSwapMinGasAmount";
  SwapConfigKey2["EthSendMinGasAmount"] = "ethSendMinGasAmount";
  SwapConfigKey2["PolygonSwapMinGasAmount"] = "polygonSwapMinGasAmount";
  SwapConfigKey2["PolygonSendMinGasAmount"] = "polygonSendMinGasAmount";
  SwapConfigKey2["AvalancheSwapMinGasAmount"] = "avalancheSwapMinGasAmount";
  SwapConfigKey2["AvalancheSendMinGasAmount"] = "avalancheSendMinGasAmount";
  SwapConfigKey2["CeloSwapMinGasAmount"] = "celoSwapMinGasAmount";
  SwapConfigKey2["CeloSendMinGasAmount"] = "celoSendMinGasAmount";
  SwapConfigKey2["MonSwapMinGasAmount"] = "monSwapMinGasAmount";
  SwapConfigKey2["MonSendMinGasAmount"] = "monSendMinGasAmount";
  SwapConfigKey2["GenericL2SwapMinGasAmount"] = "genericL2SwapMinGasAmount";
  SwapConfigKey2["GenericL2SendMinGasAmount"] = "genericL2SendMinGasAmount";
  SwapConfigKey2["LowBalanceWarningGasPercentage"] = "lowBalanceWarningGasPercentage";
  return SwapConfigKey2;
})(SwapConfigKey || {});
export var NetworkRequestsConfigKey = /* @__PURE__ */ ((NetworkRequestsConfigKey2) => {
  NetworkRequestsConfigKey2["BalanceMaxRefetchAttempts"] = "balanceMaxRefetchAttempts";
  return NetworkRequestsConfigKey2;
})(NetworkRequestsConfigKey || {});
export var ChainsConfigKey = /* @__PURE__ */ ((ChainsConfigKey2) => {
  ChainsConfigKey2["OrderedChainIds"] = "orderedChainIds";
  ChainsConfigKey2["NewChainIds"] = "newChainIds";
  return ChainsConfigKey2;
})(ChainsConfigKey || {});
export var ForceUpgradeConfigKey = /* @__PURE__ */ ((ForceUpgradeConfigKey2) => {
  ForceUpgradeConfigKey2["Status"] = "status";
  ForceUpgradeConfigKey2["Translations"] = "translations";
  return ForceUpgradeConfigKey2;
})(ForceUpgradeConfigKey || {});
export var EmbeddedWalletConfigKey = /* @__PURE__ */ ((EmbeddedWalletConfigKey2) => {
  EmbeddedWalletConfigKey2["BaseUrl"] = "baseUrl";
  return EmbeddedWalletConfigKey2;
})(EmbeddedWalletConfigKey || {});
export var HomeScreenExploreTokensConfigKey = /* @__PURE__ */ ((HomeScreenExploreTokensConfigKey2) => {
  HomeScreenExploreTokensConfigKey2["EthChainId"] = "ethChainId";
  HomeScreenExploreTokensConfigKey2["Tokens"] = "tokens";
  return HomeScreenExploreTokensConfigKey2;
})(HomeScreenExploreTokensConfigKey || {});
export var OnDeviceRecoveryConfigKey = /* @__PURE__ */ ((OnDeviceRecoveryConfigKey2) => {
  OnDeviceRecoveryConfigKey2["AppLoadingTimeoutMs"] = "appLoadingTimeoutMs";
  OnDeviceRecoveryConfigKey2["MaxMnemonicsToLoad"] = "maxMnemonicsToLoad";
  return OnDeviceRecoveryConfigKey2;
})(OnDeviceRecoveryConfigKey || {});
export var UwuLinkConfigKey = /* @__PURE__ */ ((UwuLinkConfigKey2) => {
  UwuLinkConfigKey2["Allowlist"] = "allowlist";
  return UwuLinkConfigKey2;
})(UwuLinkConfigKey || {});
export var DatadogIgnoredErrorsConfigKey = /* @__PURE__ */ ((DatadogIgnoredErrorsConfigKey2) => {
  DatadogIgnoredErrorsConfigKey2["Errors"] = "errors";
  return DatadogIgnoredErrorsConfigKey2;
})(DatadogIgnoredErrorsConfigKey || {});
export var DatadogSessionSampleRateKey = /* @__PURE__ */ ((DatadogSessionSampleRateKey2) => {
  DatadogSessionSampleRateKey2["Rate"] = "rate";
  return DatadogSessionSampleRateKey2;
})(DatadogSessionSampleRateKey || {});
export var BlockedNftCollectionsConfigKey = /* @__PURE__ */ ((BlockedNftCollectionsConfigKey2) => {
  BlockedNftCollectionsConfigKey2["BlocklistedCollections"] = "blocklistedCollections";
  return BlockedNftCollectionsConfigKey2;
})(BlockedNftCollectionsConfigKey || {});
export var ExternallyConnectableExtensionConfigKey = /* @__PURE__ */ ((ExternallyConnectableExtensionConfigKey2) => {
  ExternallyConnectableExtensionConfigKey2["ExtensionId"] = "extensionId";
  return ExternallyConnectableExtensionConfigKey2;
})(ExternallyConnectableExtensionConfigKey || {});
export var QuickRouteChainsConfigKey = /* @__PURE__ */ ((QuickRouteChainsConfigKey2) => {
  QuickRouteChainsConfigKey2["Chains"] = "quick_route_chains";
  return QuickRouteChainsConfigKey2;
})(QuickRouteChainsConfigKey || {});
export var AstroChainConfigKey = /* @__PURE__ */ ((AstroChainConfigKey2) => {
  AstroChainConfigKey2["Url"] = "url";
  return AstroChainConfigKey2;
})(AstroChainConfigKey || {});
export var LPConfigKey = /* @__PURE__ */ ((LPConfigKey2) => {
  LPConfigKey2["DefaultSlippage"] = "defaultSlippage";
  LPConfigKey2["V4SlippageOverride"] = "v4SlippageOverride";
  return LPConfigKey2;
})(LPConfigKey || {});
